export class FilesTickets{
    public descripcion = null;
    public file: File;
    public size: number;
    public type: string;
    constructor(_file: File){
        this.file = _file;
        this.size = _file.size;
        this.type = _file.type;
    }
    checkDescripcion(){
        return (this.descripcion != null && this.descripcion != '' && /[^\s][\w\s]+/g.test(this.descripcion));
    }
    formatValid(){
        return (this.type == 'image/png' || this.type == 'image/jpeg' || this.type == 'application/pdf' || this.type == 'image/jpg')
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/domain/files.ts